import ReactDOM from "react-dom";

import configs from "../../configs";
import { Container } from "./styled";

export const Modal = ({ children, isSelector = false }) => {
  return ReactDOM.createPortal(
    <Container>{children}</Container>,
    document.getElementById(
      isSelector ? configs.SELECTOR_PORTAL_KEY : configs.PORTAL_KEY
    )
  );
};
